import { Instagram, Facebook, ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal, Overline, OrnamentDivider } from "./Reveal";
import { useLang } from "../i18n";

const CARDS = [
    {
        id: "instagram",
        icon: Instagram,
        name: "Instagram",
        handle: "@royaltadka2026",
        href: "https://www.instagram.com/royaltadka2026",
        testId: "social-instagram-button",
    },
    {
        id: "facebook",
        icon: Facebook,
        name: "Facebook",
        handle: "Royal Tadka",
        href: "https://www.facebook.com/share/1BWoP8Mu2u/",
        testId: "social-facebook-button",
    },
];

export const Social = () => {
    const { t } = useLang();
    return (
        <section id="follow" data-testid="follow-us-section" className="relative py-20 sm:py-28 overflow-hidden">
            <div
                className="absolute inset-0"
                style={{ background: "radial-gradient(ellipse 55% 45% at 50% 50%, rgba(217,119,6,0.08), transparent 70%)" }}
                aria-hidden="true"
            />
            <div className="relative max-w-4xl mx-auto px-5 sm:px-8 text-center">
                <Reveal>
                    <Overline>{t("social.overline")}</Overline>
                    <h2 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl text-cream leading-[1.05]">
                        {t("social.h1a")} <span className="italic gold-text">{t("social.h1b")}</span>
                    </h2>
                    <OrnamentDivider className="mt-6 justify-center" />
                    <p className="mt-6 text-stone-400 font-light max-w-lg mx-auto">{t("social.sub")}</p>
                </Reveal>

                <div className="mt-12 grid sm:grid-cols-2 gap-5 max-w-2xl mx-auto">
                    {CARDS.map((c, i) => (
                        <Reveal key={c.id} delay={0.1 * i}>
                            <motion.a
                                data-testid={c.testId}
                                href={c.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                whileHover={{ scale: 1.03, y: -4 }}
                                whileTap={{ scale: 0.98 }}
                                transition={{ type: "spring", stiffness: 300, damping: 20 }}
                                className="group flex items-center gap-5 gold-border rounded-2xl bg-elevated/60 p-6 sm:p-7 text-left hover:border-saffron/60 hover:shadow-[0_20px_50px_rgba(217,119,6,0.15)] transition-[border-color,box-shadow] duration-500"
                            >
                                <span className="w-14 h-14 rounded-full gold-border bg-ink/60 flex items-center justify-center shrink-0 group-hover:border-saffron/60 transition-colors duration-500">
                                    <c.icon className="w-6 h-6 text-saffron-glow" strokeWidth={1.5} />
                                </span>
                                <span className="flex-1 min-w-0">
                                    <span className="block font-serif text-2xl text-cream group-hover:text-saffron-glow transition-colors duration-300">
                                        {c.name}
                                    </span>
                                    <span className="block text-sm text-stone-400 mt-0.5 truncate">{c.handle}</span>
                                </span>
                                <span className="flex items-center gap-1.5 text-[11px] tracking-[0.2em] uppercase text-brass group-hover:text-saffron-glow transition-colors duration-300 shrink-0">
                                    {t("social.follow")}
                                    <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                                </span>
                            </motion.a>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
